import React from 'react';
import './SectionHeader.css';
import { GetImages } from '../../../utils/GetImages';


const SectionHeader = ({ title ,subTitle=undefined ,icon=true ,headerImg=undefined}) => {
  return (
    <div className="section-header p-2">
      {icon && (
        <div className="icon-wrapper">
        <img className="icon color-white-icon" src={headerImg ? headerImg : GetImages.homeIconBlack} />
      </div>
      ) }
      
      <div className='d-flex flex-column '>
      <p className={`heading black${subTitle ? " mb-1" : ""}`}>{title}</p>
     {subTitle && ( <p className='normal_text'>{subTitle}</p>)}
     </div>
    </div>
  );
};

export default SectionHeader;
